Vue.component('cookiebot-declaration', {
    name: 'CookiebotDeclaration',
    props:{
        domainId: {
            type: String,
            required: true
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            // Load external js
            const script = document.createElement('script');
            script.src = 'https://consent.cookiebot.com/' + this.domainId + '/cd.js';
            document.getElementById('app').appendChild(script);

            this.$root.cookiebotDeclarationLoaded = true;
        }
    }
});
